import {
  
  GET_USER_STATUS_DEFINITIONS_SUCCESS,
  USER_STATUS_DEFINITION_API_ERROR,


} from "./actionTypes"

const INIT_STATE = {
  userStatusDefinitions: [],
  error: {},
}

const UserStatusDefinition = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_USER_STATUS_DEFINITIONS_SUCCESS:
      return {
        ...state,
        userStatusDefinitions: action.payload,
      }

   

    case USER_STATUS_DEFINITION_API_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    default:

      return state

  }
}

export default UserStatusDefinition